module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-group",
    class: {
      'has-error': _vm.errors.has('selected_template_id')
    },
    on: {
      "change": _vm.revalidate
    }
  }, [(_vm.show_select) ? _c('div', {
    staticClass: "footer",
    class: {
      'has-error': _vm.errors.has('selected_template_id')
    }
  }, [_c('template-autocomplete', {
    directives: [{
      name: "validate",
      rawName: "v-validate",
      value: (_vm.select_validation),
      expression: "select_validation"
    }],
    attrs: {
      "kind": _vm.template_kind,
      "open_template_modal": true,
      "external_id": _vm.action.step,
      "user_id": _vm.flow.user_id,
      "data-vv-name": "selected_template_id"
    },
    on: {
      "template-selected": _vm.templateSelected,
      "destroy-created-template": _vm.destroyCreatedTemplate,
      "open-template-modal": _vm.openCreateTemplateModal
    }
  })], 1) : _vm._e(), _c('div', {
    staticClass: "action-wrapper cancel-wrapper"
  }, [(_vm.show_cancel_editing) ? _c('button', {
    staticClass: "cancel-editing btn btn-sm",
    on: {
      "click": _vm.cancelEditing
    }
  }, [_vm._v(_vm._s(_vm.$t('general.actions.cancel')))]) : _vm._e()]), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.show_select),
      expression: "!show_select"
    }],
    staticClass: "template-name"
  }, [_vm._v(_vm._s(_vm.action.name)), _c('div', {
    staticClass: "action-wrapper"
  }, [(!_vm.options.disabled) ? _c('button', {
    staticClass: "edit-template btn btn-sm button-tooltip pull-right",
    attrs: {
      "data-toggle": "tooltip",
      "title": _vm.$t('template.label.editTemplateAction'),
      "data-placement": "top"
    },
    on: {
      "click": _vm.editTemplate
    }
  }, [_vm._v(_vm._s(_vm.$t('template.actions.edit')))]) : _vm._e()])]), _c('create-template-modal', {
    attrs: {
      "element_id": _vm.create_modal_element_id,
      "template": _vm.created_template,
      "options": _vm.template_modal_options
    },
    on: {
      "validation-success": _vm.createTemplate,
      "cancel": _vm.cancelTemplateChange,
      "destroy": _vm.destroyCreatedTemplate
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-156c05b0!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/templates/picker.vue
// module id = 1024
// module chunks = 1